export default function getInitialPlaybackState() {
  return {
    adDuration: 0,
    adPlaying: false,
    adTime: 0,
    buffered: [],
    currentQuestion: null,
    currentQuestionNode: null,
    didInitiallyStall: false,
    displayingInfo: false,
    duration: null,
    emitter: null,
    ended: false,
    isChangingInterviewQuestion: false,
    justScrubbed: false,
    orientation: null,
    playing: false,
    playingSubchapter: false,
    posterImage: null,
    resumePlaybackAfterScrub: false,
    scrubbing: false,
    scrubTime: 0,
    seeking: false,
    slideshowCaptionsShowing: false,
    stalled: false,
    stateKey: null,
    time: 0,
    timeBeforeScrub: null,
    totalNumberOfQuestions: 0,
    userInitiatedPause: false,
  };
}
